<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card" ref="formContainer">
          <div class="card-body">
            <div class="row issue-meta-row">
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Voucher Code</label>
                  <b-form-input type="text" v-model="forms[0].vouchercode" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 col-12">
                <div class="form-group">
                  <label>Issue Date</label>
                  <b-form-input
                    type="date"
                    v-model="forms[0].dispatchdate"
                    placeholder="Select dispatch date"
                    @keypress.enter="submitForm()"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-lg-4 col-sm-12 col-12">
                <div class="form-group">
                  <label>Remarks</label>
                  <b-form-input
                    type="text"
                    v-model="forms[0].remarks"
                    placeholder="Optional"
                    @keypress.enter="submitForm()"
                  />
                </div>
              </div>
            </div>
            <div v-for="(form, index) in forms" :key="index">
              <div class="row issue-line-row align-items-end">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Item Name <span v-if="index > 0" class="issue-line-label">#{{ index + 1 }}</span></label>
                    <div>
                      <model-list-select
                        :list="itemListFromApi"
                        v-model="form.dispatchitem"
                        option-value="itemid"
                        option-text="itemname"
                        placeholder="Select item"
                        :ref="`dispatchitemInput${index}`"
                        tabindex="1"
                        autofocus
                        @keypress.enter="submitForm()"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Branch</label>
                    <div class="issue-dropdown-wrap">
                      <model-list-select
                        :list="branchList"
                        v-model="form.branch"
                        option-value="branchid"
                        option-text="branchname"
                        placeholder="Select branch"
                        @keypress.enter="submitForm()"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Issue To</label>
                    <div class="issue-select-wrap">
                      <select class="form-control issue-select-control" v-model="form.issuedto" @change="handleIssuedToChange(form)">
                        <option value="BRANCH">Branch</option>
                        <option value="DEALER">Dealer</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div v-if="form.issuedto === 'DEALER'" class="col-lg-2 col-sm-6 col-12">
                  <div class="form-group">
                    <label>Dealer</label>
                    <div class="issue-dropdown-wrap">
                      <model-list-select
                        :list="getDealersForBranch(form.branch)"
                        v-model="form.dealerid"
                        option-value="dealerid"
                        option-text="dealername"
                        placeholder="Select dealer"
                      >
                      </model-list-select>
                    </div>
                  </div>
                </div>
                <div :class="form.issuedto === 'DEALER' ? 'col-lg-2 col-sm-6 col-6' : 'col-lg-4 col-sm-6 col-6'">
                  <div class="form-group">
                    <label>Quantity</label>
                    <b-form-input type="number" v-model.number="form.quantity" min="0" max="999999.99" @input="validateQuantity(form)" @keypress.enter="submitForm()"/>
                  </div>
                </div>
                <div class="col-lg-1 col-sm-6 col-6">
                  <div class="form-group issue-action-group">
                    <label class="issue-action-label">&nbsp;</label>
                    <button
                      v-if="index > 0"
                      @click="removeForm(index)"
                      type="button"
                      class="btn btn-danger issue-remove-btn"
                      aria-label="Remove item"
                      title="Remove item"
                    >
                      ×
                    </button>
                  </div>
                </div>
              </div>
              <hr class="issue-row-divider"/>
            </div>
            <button @click="addForm" class="btn btn-success me-2">Add More</button>
            <button @click="submitForms" class="btn btn-primary me-2" >Submit All</button>
            <router-link to="saleslist" class="btn btn-secondary">Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import Swal from "sweetalert2";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';

export default {
  data() {
    return {
      forms:[
        {
          dispatchitem: '',
          quantity: '0',
          vouchercode: '',
          branch: '',
          issuedto: 'BRANCH',
          dealerid: '',
          remarks: '',
          dispatchdate: moment().format("YYYY-MM-DD"),
        },
      ],
      title: "Issue Item",
      title1: "Create new Issue Item",
      branchList: [],
      dealerList: [],
      itemListFromApi: [],
    };
  },
  created(){
    this.fetchItemListFromApi();
    this.fetchBranchListFromApi();
    this.fetchDealerListFromApi();
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/add-sales' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault();
        this.addForm();
      }
    },
    validateQuantity(form) {
      const quantity = parseFloat(form.quantity);
      if (quantity < 0) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid Quantity',
          text: 'Quantity must be a positive number.',
        });
        form.quantity = Math.max(quantity, 0);
      }
    },
    addForm() {
      if (this.forms.length < 20) {
        this.forms.push({
          dispatchitem: '',
          quantity: '0',
          branch: '',
          issuedto: 'BRANCH',
          dealerid: '',
          remarks: '',
          dispatchdate: this.forms[0].dispatchdate,
        });
        this.$nextTick(() => {
          const newIndex = this.forms.length - 1;
          if (this.$refs[`dispatchitemInput${newIndex}`] && this.$refs[`dispatchitemInput${newIndex}`][0]) {
            this.$refs[`dispatchitemInput${newIndex}`][0].$el.focus();
          }
        });
      }
      if (this.forms.length >= 20) {
        Swal.fire("You can add a maximum of 20 forms.");
      }
    },
    removeForm(index) {
      this.forms.splice(index, 1);
    },
    async fetchItemListFromApi() {
      try {
        const response = await axios.get('/v1/items');
        this.itemListFromApi = response.data; // Update with your actual API response structure
      } catch (error) {
        console.error('Error fetching item list:', error);
      }
    },
    async fetchBranchListFromApi() {
      try {
        const response = await axios.get('/v1/branches');
        this.branchList = response.data;
      } catch (error) {
        console.error('Error fetching branch list:', error);
      }
    },
    async fetchDealerListFromApi() {
      try {
        const response = await axios.get('/v1/dealers');
        this.dealerList = response.data;
      } catch (error) {
        console.error('Error fetching dealer list:', error);
      }
    },
    getDealersForBranch(branchId) {
      return this.dealerList.filter(dealer => (dealer.branchids || []).includes(branchId));
    },
    handleIssuedToChange(form) {
      if (form.issuedto !== 'DEALER') {
        form.dealerid = '';
      }
    },
    async submitForms() {
      try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
        const allFormData = [];
        const firstForm = this.forms[0];

        this.forms.forEach(form => {
          if (form.issuedto === 'DEALER' && !form.dealerid) {
            throw new Error('Please select a dealer for dealer issue');
          }
          const selectedDate = moment(firstForm.dispatchdate).format("YYYY-MM-DD")
          const currentTime = moment().format("HH:mm:ss");

          allFormData.push({
            dispatchitem: form.dispatchitem,
            quantity: form.quantity,
            vouchercode: firstForm.vouchercode,
            branch: form.branch,
            issuedto: form.issuedto,
            dealerid: form.issuedto === 'DEALER' ? form.dealerid : null,
            remarks: firstForm.remarks || null,
            dispatchdate: `${selectedDate}T${currentTime}`,
          });
        });

        this.postData(allFormData);
      }
      } catch (error) {
        Swal.fire(error.message);
      }
    },
    postData(forms) {
      axios
        .post('/v1/dispatches', forms)
        .then(response => {
//this.res = "Status " + response.status + ". Category created";
          Swal.fire("Issue Item created successfully");
          this.$router.push({ path: '/saleslist' });
        })
        .catch(error => {
          console.log(error);
          Swal.fire(error.response.data.detail);
        });
    },
    submitForm() {
      this.submitForms();
    }

  },
  components: {
    ModelListSelect
  },

  name: "add-sales",
};
</script>  
<style scoped>
.issue-meta-row {
  margin-bottom: 8px;
}

.issue-line-row {
  margin-bottom: 4px;
}

.issue-row-divider {
  border-top: 1px solid #e9ecef;
  margin: 6px 0 14px;
}

.issue-line-label {
  color: #ff9f43;
  font-size: 12px;
  font-weight: 600;
}

.issue-action-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.issue-action-label {
  visibility: hidden;
}

.issue-remove-btn {
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
}

.issue-dropdown-wrap {
  width: 100%;
}

.issue-select-wrap {
  position: relative;
  width: 100%;
}

.issue-select-wrap::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 14px;
  width: 8px;
  height: 8px;
  border-right: 2px solid #637381;
  border-bottom: 2px solid #637381;
  pointer-events: none;
  transform: translateY(-65%) rotate(45deg);
}

.issue-select-control {
  appearance: none;
  background-color: #fff;
  cursor: pointer;
  padding-right: 40px;
}

.issue-select-control:focus {
  border-color: #ff9f43;
  box-shadow: 0 0 0 0.2rem rgba(255, 159, 67, 0.15);
}

@media (min-width: 992px) {
  .issue-line-row :deep(.model-list-select),
  .issue-line-row :deep(.ui.selection.dropdown),
  .issue-line-row :deep(input),
  .issue-line-row select {
    min-height: 38px;
  }

  .issue-line-row :deep(.model-list-select) {
    width: 100%;
  }

  .issue-line-row :deep(.ui.selection.dropdown) {
    width: 100%;
    min-width: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
